export function getMorningInvoiceUrl(): string {
  return `https://app.sandbox.d.greeninvoice.co.il/incomes`;
}
